import { TBaseComponentProps } from '@segway/core'

/**
 * 默认 Layout
 */
const EmptyLayout = (props: TBaseComponentProps) => {
  return <>{props.children}</>
}

export default EmptyLayout
